import { useEffect, useRef, useState } from "react"
import { useSelector } from "react-redux"
import { Grid } from "semantic-ui-react"
import Censio_guidelines from "../../assets/img/Censio-guideline-trim.png";
import fullscreen_maximize_icon from "../../assets/img/fullscreen_maximize_icon.svg";
import exit_fullscreen_minimize_icon from "../../assets/img/exit_fullscreen_minimize_icon .svg";
import Chatbot from "../CommonComponent/chatbotLayout";

const GameInstructions = () => {
    const showGame = useSelector((state) => state.componentReducer.showgame)

    const iframeref = useRef()
    const [showiframeGame, setshowiframeGame] = useState(false)
    const [showFullScreen, setShowFullScreen] = useState(false)
    const [isChatBotOpen, setIsChatBotOpen] = useState(false)

    useEffect(() => {
        if (showiframeGame) {
            console.log("iframe height width")
            console.log("parent frame cw " + iframeref.current.clientWidth);
            console.log("parent frame ow " + iframeref.current.offsetWidth);
            console.log("parent frame sw " + iframeref.current.style.width);
            console.log("parent window h " + window.innerWidth);
            console.log("parent window w " + window.innerHeight);
            console.log("parent innerHTML w " + iframeref.current);
        }
    }, [showiframeGame, showFullScreen])
    const handleClick = () => {
        // if (gamename === "Wordplay") {
        // window.open(`https://censiobeta.in/Censiowordplay/?token=${ssoToken}`, "_self")
        // } else {
        setshowiframeGame(true)
        // }
    }

    const handleIfameScreenSize = () => {
        setShowFullScreen(prev => !prev)
    }

    const getChatBotIsOpen = (value) => {
        setIsChatBotOpen(value)
    }
    return (
        <>
            {!showiframeGame ?
                <div className="game__instruction-container dark:bg-[#212121]">
                    <Grid>
                        <Grid.Row style={{ paddingBottom: '0', alignItems: 'center' }}>

                            <Grid.Column computer={12} tablet={12} mobile={16} className="m-auto">
                                <div className="game__play-guideline">
                                    <img src={Censio_guidelines} width={"75%"} height={"100%"} alt="game_insructions" />
                                    <button onClick={handleClick}>Ok</button>
                                </div>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>

                </div>
                :
                <div className={`flex items-start gap-2 ${showFullScreen ? 'fixed z-40 h-screen w-screen overflow-y-auto top-0 left-0 flex justify-center items-center bg-[#3E40488C]' : 'w-full h-full relative'}`}>
                    <iframe ref={iframeref} src={showGame} title="Game" allowFullScreen="" controls="" frameBorder="0" scrolling="no" style={showFullScreen ? { width: '100%', height: '100%' } : { width: '100%' }} className={`dark:bg-[#212121]`} />
                    <div className={`absolute bg-white p-[0.5rem] rounded-full cursor-pointer ${showFullScreen ? 'top-[1rem] right-[2rem]' : 'top-[7rem] right-[0.5rem] border shadow border-gray-300'}`} onClick={handleIfameScreenSize}>
                        {
                            showFullScreen ? <img src={exit_fullscreen_minimize_icon} alt="exit_fullscreen_minimize_icon" className="w-6 h-6" />
                                : <img src={fullscreen_maximize_icon} alt="fullscreen_maximize_icon" className="w-6 h-6" />
                        }
                    </div>
                    <div className={`absolute bottom-[7rem] right-[0.5rem] border shadow border-gray-300`}>
                        <div className={`chat-panel overflow-y-auto relative ${isChatBotOpen ? 'w-2/6' : 'w-20'}`}>
                            <Chatbot
                                getIsOpen={getChatBotIsOpen}
                                className={`fixed right-14 bottom-14 z-50 bg-[#eaf1fe] dark:bg-[#1A3647] dark:bg-gray-200 p-1.5 pb-2  rounded-lg shadow border-2 border-gray-300 shadow-[#eaf1fe] dark:shadow-gray-700 ${isChatBotOpen ? 'w-[27%] h-3/4' : ''}`} />
                        </div>
                    </div>
                </div>
            }
        </>
    )
}

export default GameInstructions